// Shared wording for session times on the member booking pages.
import { formatDayDate, formatTime } from '../../utils/dates';

// "Sat 17 Oct 2026, 17:00 to 18:30"
export function sessionWhen(date, template) {
  return `${formatDayDate(date)}, ${template.startTime} to ${template.endTime}`;
}

// "today at 18:00", "tomorrow at 09:30" or "Mon 19 Oct 2026 at 18:00", so an
// offer that runs out at midnight doesn't just say "00:00"
export function whenExpires(date, now = new Date()) {
  const d = new Date(date);
  const time = formatTime(d);
  const startOf = x => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const days = Math.round((startOf(d) - startOf(now)) / 86400000);
  if (days === 0) return `today at ${time}`;
  if (days === 1) return `tomorrow at ${time}`;
  return `${formatDayDate(d)} at ${time}`;
}
